import {CheckoutHeaderLogoModel} from './CheckoutHeaderLogo.model';
import {EcommerceSettings} from '@wix/wixstores-client-storefront-sdk';

export type CheckoutHeaderType = NonNullable<
  NonNullable<EcommerceSettings['checkoutSettings']>['checkoutBrand']
>['header'];

export class CheckoutHeaderModel {
  public alignment?: string;
  public displayCheckoutLabel?: boolean;
  public logo?: CheckoutHeaderLogoModel;

  constructor(checkoutHeader?: CheckoutHeaderType) {
    this.alignment = checkoutHeader?.alignment ?? /* istanbul ignore next */ undefined;
    this.displayCheckoutLabel = checkoutHeader?.displayCheckoutLabel ?? /* istanbul ignore next */ false;
    this.logo = new CheckoutHeaderLogoModel(checkoutHeader?.logo ?? /* istanbul ignore next */ undefined);
  }
}
